export default __webpack_public_path__ + "static/award-logo-3-f1a9782ccbbbba8185ed8df882789352.svg";